/* BKS — bouton « retour » en haut à droite de tous les configurateurs (pages plein écran, sans le menu du site).
   · configurateur ouvert depuis une fiche (…/products/<fiche>?view=…) : « ← <titre du produit> » vers la fiche ;
   · page configurateur (FUSION, VELTO, scooter, cross) : retour vers la fiche d'où vient le client (même site),
     sinon « ← Accueil ». Le titre vient de /products/<fiche>.js. */
(function(){
'use strict';
if(window.__bksRetour)return; window.__bksRetour=1;
function css(){
  var s=document.createElement('style');
  s.textContent='.bks-retour{display:inline-flex;align-items:center;gap:6px;max-width:min(46vw,360px);padding:7px 12px;border-radius:999px;'
    +'border:1px solid rgba(139,92,246,.55);background:rgba(139,92,246,.12);color:#fff;font:700 12.5px/1.2 inherit;text-decoration:none;'
    +'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:background .15s,border-color .15s}'
    +'.bks-retour:hover{background:rgba(139,92,246,.28);border-color:#8B5CF6}'
    +'.bks-retour b{font-weight:900;flex:0 0 auto}.bks-retour span{overflow:hidden;text-overflow:ellipsis}'
    +'.bks-hdr-droite{display:flex;align-items:center;gap:12px;min-width:0}'
    +'@media (max-width:600px){.bks-retour{max-width:44vw;padding:6px 10px;font-size:11.5px}.bks-hdr-droite{gap:8px}}';
  document.head.appendChild(s);
}
function fiche(path){ var m=String(path||'').match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^\/?#]+)/i); return m?m[1]:null; }
function poser(url,titre){
  var h=document.querySelector('.hdr'); if(!h||h.querySelector('.bks-retour'))return;
  var a=document.createElement('a'); a.className='bks-retour'; a.href=url; a.title='Revenir à : '+titre;
  a.innerHTML='<b>←</b><span></span>'; a.querySelector('span').textContent=titre;
  var stp=h.querySelector('.stp');
  if(stp){ var d=document.createElement('div'); d.className='bks-hdr-droite'; stp.parentNode.insertBefore(d,stp); d.appendChild(stp); d.appendChild(a); }
  else h.appendChild(a);
}
function demarrer(){
  css();
  var ici=fiche(location.pathname), ref='';
  try{ var r=new URL(document.referrer); if(r.origin===location.origin)ref=r.pathname; }catch(e){}
  var cible=ici||(fiche(ref)&&ref.split('?')[0]!==location.pathname?fiche(ref):null);
  if(!cible){ poser('/','Accueil'); return; }
  var url='/products/'+cible;
  poser(url,'Retour au produit');
  fetch(url+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(j){
    if(!j||!j.title)return; var s=document.querySelector('.bks-retour span'); if(s)s.textContent=j.title; var a=document.querySelector('.bks-retour'); if(a)a.title='Revenir à : '+j.title;
  }).catch(function(){});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',demarrer); else demarrer();
})();
